export enum FileExtensionType {
  CSV = 'CSV',
  EXCEL = 'EXCEL',
  PNG = 'PNG'
}
